import { render } from "./StatisticsTable.vue?vue&type=template&id=20bee0e6&scoped=true"
import script from "./StatisticsTable.vue?vue&type=script&lang=js"
export * from "./StatisticsTable.vue?vue&type=script&lang=js"

import "./StatisticsTable.vue?vue&type=style&index=0&id=20bee0e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bee0e6"]])

export default __exports__